/* Complete Anti-Wrinkle System — smooth anchor scroll to the offer.

   Progressive enhancement over real <a href="#offer"> links: intercepts clicks
   on [data-caws-scroll] and scrolls to the offer target. Honors
   prefers-reduced-motion by falling back to an instant jump. With JS off the
   anchors still work natively. Delegated so it also covers dynamically shown
   elements (e.g. the sticky bar). */
(function () {
  if (window.__cawsScrollInit) return;
  window.__cawsScrollInit = true;

  const prefersReduced = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Capture phase so we run before the theme's own anchor handlers, which
  // otherwise swallow "#offer" clicks and stop the page from scrolling.
  window.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('[data-caws-scroll]');
      if (!trigger) return;

      const hash = (trigger.getAttribute('href') || '#offer').replace(/^.*#/, '#');
      const id = hash.slice(1);
      const target = id ? document.getElementById(id) : null;
      if (!target) return; // let the browser handle it

      event.preventDefault();
      event.stopPropagation();
      target.scrollIntoView({
        behavior: prefersReduced() ? 'auto' : 'smooth',
        block: 'start',
      });

    // Move focus for keyboard + screen-reader users without a second jump.
    const hadTabindex = target.hasAttribute('tabindex');
    if (!hadTabindex) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    if (!hadTabindex) {
      target.addEventListener(
        'blur',
        () => target.removeAttribute('tabindex'),
        { once: true }
      );
    }
    },
    true
  );
})();
